// React
import React, { useRef, useState, useEffect } from 'react';

// Packages
import sanitizeHtml from 'sanitize-html';

// Utilities
import { useInitiativeDataStore } from 'utilities/store';
import { useContext } from 'utilities/hooks';

// Components
import Report_5_0_PDF from 'components/_report/templates/report_5_0_pdf';
import Report_4_0_PDF from 'components/_report/templates/report_4_0_pdf';

const useReportContent = () => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { REPORT_ID } = useContext();

    // ///////////////////
    // REFS
    // ///////////////////

    const dataRef = useRef(null);

    // ///////////////////
    // DATA
    // ///////////////////

    const report = utilities.reports.get(REPORT_ID);

    // ///////////////////
    // METHODS
    // ///////////////////

    async function getSanitizedHtml() {
        if (!dataRef.current) return '';
        const rawHtml = dataRef.current.innerHTML;
        const clean = sanitizeHtml(rawHtml, {
            allowedTags: [],
            allowedAttributes: {},
            allowedIframeHostnames: [],
        });
        return JSON.stringify(clean);
    }

    // ///////////////////
    // RENDER
    // ///////////////////

    const HiddenRender = (
        <div ref={dataRef} className="hidden" aria-hidden="true">
            {report.Report_Viewer_Version__c === 4.0 ? (
                <Report_4_0_PDF />
            ) : (
                <Report_5_0_PDF />
            )}
        </div>
    );

    return { HiddenRender, getSanitizedHtml };
};

export default useReportContent;
